<template>
  <BaseButton primary @click="openNewPipelineDialog"> New Pipeline </BaseButton>
</template>

<script>
import apiFetch from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    submit(data) {
      return apiFetch.post(`/accounts/${this.accountId}/pipelines`, data).then((response) => {
        this.$emit('created');

        this.$router.push({
          name: 'accounts.pipelines.pipelineUuid',
          params: {
            accountId: this.accountId,
            pipelineUuid: response.data.data.id,
          },
        });

        return Promise.resolve(response);
      });
    },
    openNewPipelineDialog() {
      this.$modal.show({
        component: () =>
          import('@/components/Pipelines/CreatePipelineDialog/CreatePipelineDialog.vue'),
        props: {
          accountId: this.accountId,
          action: this.submit,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
